import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { GatewayService } from 'src/app/gateway.service';
import { Subscription } from 'rxjs/Subscription';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { BusquedaService } from 'src/app/home/busqueda.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-monitoragentes',
	templateUrl: './monitoragentes.component.html',
	styleUrls: ['./monitoragentes.component.scss']
})
export class MonitoragentesComponent implements OnInit {
  private destroy$ = new Subject<void>();

	diarioColumns: string[] = [
		'AGENTE',
		'ESTADO',
		'REGISTROS',
		'VPH',
		'CONTACTABILIDAD',
		// 'CONVERSION', 
		// 'EFECTIVIDAD'
	];
	dataSource = new MatTableDataSource<any>([]);
	private filtroagente = '';
	public campana = { nombre: '' };

	private subscription: Subscription;
	interval;

	constructor(
		private spinner: NgxSpinnerService,
		private gateway: GatewayService,
		private router: Router,
		private _busqueda: BusquedaService,
		private localsave: LocalSaveService
	) { }

	ngOnInit() {
		this.loadagentes();
		this._busqueda.cleanBusqueda();
		this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.filtroagente = res.filtro;
				this.loadagentes();
			});

		this.interval = setInterval(() => {
			this.reload();
		}, 60000)
	}

	ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
		this._busqueda.cleanBusqueda();
		this.subscription.unsubscribe();
		clearInterval(this.interval);
	}

	loadagentes() {
		this.spinner.show();

		this.gateway.get('monitordeagentes', { FILTRO: this.filtroagente, IDDISTRIBUIDOR: this.localsave.get('usuarioPGV').IDU, ESDISTRIBUIDOR: this.localsave.get('usuarioPGV').esDistribuidor, IDAREA: this.localsave.get('usuarioPGV').IDAREA }).then((result: any) => {
			this.dataSource = new MatTableDataSource(result.rows);
			this.spinner.hide();
		}
		).catch(function (e) {
		});
	}

	reload() {
		this.loadagentes();
	}

	descargaExcel() {

		let datareport = [];
		clearInterval(this.interval);
		this.spinner.show();
		this.gateway.get('monitordeagentes', { FILTRO: this.filtroagente, IDDISTRIBUIDOR: this.localsave.get('usuarioPGV').IDU, ESDISTRIBUIDOR: this.localsave.get('usuarioPGV').esDistribuidor, IDAREA: this.localsave.get('usuarioPGV').IDAREA }).then((result: any) => {
			datareport = result.rows;

			datareport.forEach(function (currentItem) {
				delete currentItem['idagente'];
				delete currentItem['idestado'];

				Object.defineProperty(currentItem, 'Nombre agente', Object.getOwnPropertyDescriptor(currentItem, 'nombre'));
				delete currentItem['nombre'];

				Object.defineProperty(currentItem, 'Apellido agente', Object.getOwnPropertyDescriptor(currentItem, 'apellido'));
				delete currentItem['apellido'];

				Object.defineProperty(currentItem, 'Estado', Object.getOwnPropertyDescriptor(currentItem, 'estado'));
				delete currentItem['estado'];

				Object.defineProperty(currentItem, 'Registros', Object.getOwnPropertyDescriptor(currentItem, 'registros'));
				delete currentItem['registros'];

				Object.defineProperty(currentItem, 'VPH', Object.getOwnPropertyDescriptor(currentItem, 'vph'));
				delete currentItem['vph'];

				Object.defineProperty(currentItem, 'Contactabilidad', Object.getOwnPropertyDescriptor(currentItem, 'contactabilidad'));
				delete currentItem['contactabilidad'];

				Object.defineProperty(currentItem, 'Conversion', Object.getOwnPropertyDescriptor(currentItem, 'conversion'));
				delete currentItem['conversion'];

				Object.defineProperty(currentItem, 'Efectividad', Object.getOwnPropertyDescriptor(currentItem, 'efectividad'));
				delete currentItem['efectividad'];
			});
			//  console.log(datareport)
			const fileName = 'Monitor_agentes_' + Date.now();
			const wb: XLSX.WorkBook = XLSX.utils.book_new();
			const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(datareport);
			XLSX.utils.book_append_sheet(wb, ws);

			const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
			saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
			this.spinner.hide();
			this.interval = setInterval(() => {
				this.reload();
			}, 60000)
		}
		).catch(function (e) {
		});

	}

}
